// import { userCredentials } from './../../../../e2e/fixtures/config-data';
import { CookieStorage } from 'app/base/services/cookie-storage.service';
import { Injectable } from '@angular/core';

import { Observable ,  of } from 'rxjs';
import { UserService } from 'app/base/services/user.service';
import { LocalDataStoreService } from 'app/base/services/local-data-store.service';
// import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';


@Injectable()
export class CountriesResolveGuardService  {
  constructor(
    private cookieStorage: CookieStorage,
    private userService: UserService,
    private localDataStoreService: LocalDataStoreService
  ) {
  }

  resolve(): Observable<any> {
    if (this.localDataStoreService.countriesList) {
      return of(this.localDataStoreService.countriesList);
    }
    const token = this.cookieStorage.getCookie('token');
    if (token) {
      return this.userService.getCountries().pipe(map(res => {
        this.localDataStoreService.setCountries(res.data);
        return res;
      }));
    }
  }
}
